import {
	EssityColumnProps,
	filterType,
} from '@components/shared/paginatedEssityTable/GridHelper';
import { AccountRoleDto, AccountUserDto } from '@services/src/models';
import * as RolesMapper from 'authorization/Roles';
import { AccountRoles } from 'authorization/Roles';

export const BusinessAccountsTableColumns: EssityColumnProps<AccountUserDto>[] = [
	{
		sorter: true,
		dataIndex: 'displayName',
		key: 'displayName',
		title: 'Display Name',
		filter: 'contains' as filterType,
	},
	{
		sorter: true,
		dataIndex: 'email',
		key: 'email',
		title: 'E-mail',
		filter: 'contains' as filterType,
	},
	{
		sorter: false,
		dataIndex: 'roles',
		key: 'roles',
		title: 'Role',
		render: (values: AccountRoleDto[]) => {
			return values
				.map((x) => RolesMapper.map(x.name as AccountRoles))
				.join(',');
		},
	},
];
